import React from "react";
import {useTable, usePagination, useGlobalFilter, useSortBy} from "react-table";
import {
  Table,
  TableRow,
  TableCell,
  TableBody,
  Paper,
  TableContainer,
} from "@mui/material";
import TableHeader from "./sub-components/TableHeader";

function BasicEditableTable({columns, data, updateLocalState, defaultColumn , pageSize = 12}) {
  const {getTableProps, getTableBodyProps, headerGroups, page, prepareRow} =
    useTable(
      {
        columns,
        data,
        defaultColumn: defaultColumn && defaultColumn,
        initialState: {
          pageSize: pageSize,
          hiddenColumns: columns
            .filter((col) => col.show === false)
            .map((col) => col.accessor),
        },
        updateLocalState: updateLocalState && updateLocalState,
      },
      useGlobalFilter,
      useSortBy,
      usePagination
    );

  return (
    <>
      <TableContainer component={Paper}>
        <Table
          {...getTableProps()}
          sx={{
            borderCollapse: "separate",
            minWidth: "max-content",
          }}
        >
          <TableHeader headerGroups={headerGroups} />
          <TableBody {...getTableBodyProps()}>
            {page.map((row) => {
              prepareRow(row);
              return (
                <TableRow
                  {...row.getRowProps()}
                  sx={{
                    "& td": {bgcolor: "background.paper", cursor: "pointer"},
                  }}
                >
                  {row.cells.map((cell) => {
                    return (
                      <TableCell {...cell.getCellProps()}>
                        {cell.render("Cell")}
                      </TableCell>
                    );
                  })}
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
}

export default BasicEditableTable;
